import {LitElement, PropertyValues, html} from "lit";
import {customElement, property, query, state} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";
import {Placement} from "@floating-ui/dom";

import {Integration} from "../../../integrations/index.js";

import {iconStyles} from "../styles/Icons.js";
import {iconButtonStyles} from "./IconButton.styles.js";

import {attachTooltip, TooltipInstance} from "../tooltipControl.js";

@customElement("pn-icon-button")
export class IconButton extends LitElement {
	static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

	static styles = [iconStyles, iconButtonStyles];

	tooltipInstance: undefined | TooltipInstance;

	@property({type: String})  className:       string;
	@property({type: Boolean}) disabled = false;
	@property({type: String})  icon = "";
	@property()                isMask = false;
	@property()                onClick:         (event: PointerEvent) => void;
	@property()                onKeyDown:       (event: KeyboardEvent) => void;
	@property({type: Boolean}) showToolTip = true;
	@property()                tooltipPosition: Placement;
	@property({type: String})  tooltipText = "";
	@property({type: String})  type = "button";
	// ..rest?

	@query("button") _tooltipRefElem: HTMLElement;

	@state() isPqIntegration = false;

	firstUpdated() {
		this.tooltipInstance = attachTooltip(this._tooltipRefElem, {
			tooltipPosition: this.tooltipPosition,
			tooltipText:     this.tooltipText
		});

		this.isPqIntegration = Integration.isIntegration() && Integration.name === "proquest";
	}

	protected updated(changedProperties: PropertyValues): void {
		if (changedProperties.has("tooltipText"))
			this.tooltipInstance?.updateTooltipText(this.tooltipText);
	}

	render() {
		return html`<button
			class="${classMap({
				[this.className]: this.className,
				"__pq-int__":     this.isPqIntegration
			})}"
			aria-label=${this.tooltipText}
			?disabled=${this.disabled}
			@click=${this.onClick}
			@keydown=${this.onKeyDown}
			part="button"
			type=${this.type}
		>
			<i
				class="${classMap({
					[`icon-${this.icon}`]: true,
					"icon-mask":           this.isMask
				})}"
				part="i"
			></i>
		</button>
		`;
	}
};

// TODO:
// {...!showToolTip && {"aria-label": tooltipText}}
// {...showToolTip && {"data-tippy-content": tooltipText}}

declare global {
	interface HTMLElementTagNameMap {
		"pn-icon-button": IconButton;
	}
}
